<template>
    <div class="c-comparison">
        <div class="c-comparison__empty" v-if="isInitialized && !items.length">
            <div class="c-msg c-msg--info is-flash">
                {{ $t('Comparison.Table.empty') }}
            </div>
        </div>

        <div class="c-comparison__header" v-if="isInitialized && false && items.length && types.length > 1">
            todo types
            <div v-for="(type, id) in types" :key="id">
                type {{ type }}
            </div>
        </div>

        <div class="c-comparison__content" v-if="isInitialized && items.length">
            <div class="c-comparison-table js-comparison-table">
                <div class="c-comparison-table__header syncscroll js-comparison-table-header" :class="{'is-sticky': isSticky}" name="comparison-table">
                    <div class="c-comparison-table__column is-aside"></div>

                    <div class="c-comparison-table__column" v-for="item in items" :key="item.id">
                        <ComparisonProduct
                            :item="item"
                            @remove="removeItem"
                        />
                    </div>
                </div>

                <div class="c-comparison-table__content syncscroll" name="comparison-table">
                    <div class="c-comparison-table__column is-aside">
                        <ComparisonGroup
                            v-for="(group, groupId) in properties" :key="groupId"
                            :group="group"
                            :groupId="groupId"
                        />

                    </div>

                    <div class="c-comparison-table__column" v-for="item in items" :key="item.id">
                        <ComparisonGroup
                            v-for="(group, groupId) in properties" :key="groupId"
                            :item-id="item.id"
                            :group="group"
                            :groupId="groupId"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { formatPrice } from "./../../../../vendor/rshop/frontend/assets/js/common/format";
import client from "./../../../../vendor/rshop/frontend/assets/js/common/client";
import { CancelToken } from "axios";

const lang = document.querySelector('html').getAttribute('lang');
let locale;

import(`../../locale/${lang}`).then((module) => {
    locale = module;
});

export default {
    components: {
        ComparisonProduct: () => import("./ComparisonProduct"),
        ComparisonGroup: () => import("./ComparisonGroup"),
    },
    data() {
        return {
            isInitialized: false,
            isSticky: false,
            types: [],
            items: [],
            properties: [],
            fetchCancelToken: null,
            fetchingProducts: true,
        }
    },
    created() {
        this.fetchComparison();

        document.addEventListener('scroll', this.checkStickiness);
    },
    watch: {
        items() {
            rEvent.dispatch('Comparison.countUpdated', {
                count: this.items.length
            });
        }
    },
    methods: {
        cancelFetchComparison() {
            if (this.fetchCancelToken) {
                this.fetchCancelToken.cancel()
            }

            this.fetchCancelToken = CancelToken.source()
        },
        fetchComparison() {
            this.cancelFetchComparison()
            this.fetchProducts()
        },
        fetchProducts() {
            this.fetchingProducts = true

            client
                .get("/comparison-fetch-products", {
                    cancelToken: this.fetchCancelToken.token,
                })
                .then((response) => {
                    if (!response.data.status) {
                        return;
                    }

                    this.types = Object.values(response.data.data.types);
                    this.items = Object.values(response.data.data.items);
                    this.properties = Object.values(response.data.data.properties);

                    rEvent.dispatch('Cart.fetchedComparisonProducts', {
                        response: response.data
                    });

                    this.isInitialized = true;
                })
                .catch((error) => {})
                .then(() => {
                    this.fetchingProducts = false
                });
        },
        checkStickiness() {
            const windowOffset = window.pageYOffset,
                tableHeaderHeight = document.querySelector('.js-comparison-table-header') ? document.querySelector('.js-comparison-table-header').offsetHeight : 0,
                tableOffset = document.querySelector('.js-comparison-table') ? document.querySelector('.js-comparison-table').offsetTop : 100000;

            this.isSticky = windowOffset > tableOffset + tableHeaderHeight;
        },
        removeItem(productId) {
            let itemIndex = -1;

            // find item
            const item = this.items.find((item, index) => {
                if (item.id === productId) {
                    itemIndex = index;

                    return true;
                }

                return false;
            });

            if (itemIndex === -1) {
                return false;
            }

            // remove item
            window.Eshop.confirm(
                locale.Swal.RemoveComparison.title,
                {
                    denyButtonText: locale.Swal.RemoveComparison.deny,
                    confirmButtonText: locale.Swal.RemoveComparison.confirm
                },
                () => {
                    document.querySelector('.swal2-confirm').classList.add('is-loading');

                    return client.post(`/remove-comparison-item/${productId}`).then((response) => {
                        window.rEvent.dispatch('Comparison.removedProduct', {
                            response: response.data,
                            product: item
                        });
                    });
                },
                (result) => {
                    if (result.isConfirmed) {
                        Eshop.alert(`"${item.name}" ${locale.Comparison.Event.itemRemoved}`);

                        this.items.splice(itemIndex, 1)
                        this.fetchComparison()
                    }
                }
            );
        }
    }
}
</script>